import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantAuthorizationService } from 'src/services/tenant-authorization.service';
import type { TenantAuthorizationRequirement } from 'src/services/tenant-authorization.service';

export const TENANT_AUTHORIZATION_ROUTE_DATA_KEY = 'tenantAuthorization';

export const tenantAuthorizationGuard: CanActivateFn = (route) => {
  const authorizationService = inject(TenantAuthorizationService);
  const router = inject(Router);
  const requirement = route.data[TENANT_AUTHORIZATION_ROUTE_DATA_KEY] as TenantAuthorizationRequirement | undefined;

  if (!requirement || !authorizationService.isAuthorized(requirement)) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
